import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const savedUser = sessionStorage.getItem('user');
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (error) {
        console.error('Error parsing saved user:', error);
        sessionStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  const login = (username, password, rememberMe, userDataOverride) => {
    const baseUserData = {
      username,
      name: username,
      hoVaTen: username,
      role: 'admin'
    };
    const userData =
      userDataOverride && typeof userDataOverride === 'object'
        ? { ...baseUserData, ...userDataOverride }
        : baseUserData;
    sessionStorage.setItem('user', JSON.stringify(userData));

    if (rememberMe) {
      localStorage.setItem('savedCredentials', JSON.stringify({ username, password }));
    } else {
      localStorage.removeItem('savedCredentials');
    }

    setUser(userData);
    return true;
  };

  const logout = () => {
    localStorage.removeItem('user');
    sessionStorage.removeItem('user');
    setUser(null);
  };

  const getSavedCredentials = () => {
    const saved = localStorage.getItem('savedCredentials');
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (error) {
        console.error('Error parsing saved credentials:', error);
        localStorage.removeItem('savedCredentials');
        return null;
      }
    }
    return null;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, getSavedCredentials }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
